import React from "react";
import PropTypes from "prop-types";

// function _onCtaEmailSubmit() {
//   window.analytics.track("email-entry");
// }

const CtaEmailForm = props => (
  <section className="ph3 ph5-ns pt3">
    <article className="mw8 center br2 ba b--light-blue bg-lightest-blue">
      <div className="cf w-100">
        <div className="pa3 pa4-ns fl w-100 w-50-ns v-mid">
          <div>
            <h2 className="fw4 blue mt0 mb3">
              For a limited time, schedule a{" "}
              <strong>free 15-minute consultation</strong> to take your battle
              against churn to the next level.
            </h2>
            <p className="black-70 measure lh-copy mv0">
              Ready to step up your customer retention game? For a short time
              we're offering completely free 15-minute calls to those who want
              to talk through{" "}
              <strong className="fw7">
                tactical, actionable ideas for reducing churn
              </strong>{" "}
              and improving customer retention.
            </p>
            <p className="black-70 measure lh-copy mv0">
              To claim your slot, enter your name and email here, then pick a
              time on the next screen.
            </p>
          </div>
        </div>
        <div className="pa3 pa4-ns mt4-ns fl w-100 w-50-ns v-mid">
          <form action={props.formUrl} method="post">
            <div>
              <label className="f5 black pr3" htmlFor="email">
                Name<sup>*</sup>
              </label>
              <input
                className="f6 f6-l input-reset bn black-80 bg-white pa3 lh-solid w-100 w-70-l"
                placeholder="Your Name"
                type="text"
                name="name"
                id="name"
                required
              />
            </div>
            <div className="mv3">
              <label className="f5 black pr3" htmlFor="email">
                Email<sup>*</sup>
              </label>
              <input
                className="f6 f6-l input-reset bn black-80 bg-white pa3 lh-solid w-100 w-70-l"
                placeholder="Your Email Address"
                type="email"
                name="email"
                id="email"
                required
              />
            </div>
            <input type="hidden" name="cc-tcu" value={props.numCustomers} />
            <input type="hidden" name="cc-tch" value={props.numChurned} />
            <input type="hidden" name="cc-cr" value={props.churnRate} />
            <input type="hidden" name="cc-arpa" value={props.arpa} />
            <input type="hidden" name="cc-tci" value={props.churnImprovement} />
            <input type="hidden" name="cc-cm1" value={props.month1} />
            <input type="hidden" name="cc-cyc" value={props.yearlyCumulative} />
            <input type="hidden" name="placement" value={props.placement} />
            <div className="tc">
              <input
                className="f6 f5-l button-reset pv3 tc bn bg-animate bg-orange hover-bg-red white pointer w-100 w-50-l br2 ba b--red"
                type="submit"
                value="Reserve Your Slot Now"
              />
            </div>
          </form>
        </div>
      </div>
    </article>
  </section>
);

CtaEmailForm.propTypes = {
  formUrl: PropTypes.string.isRequired,
  numCustomers: PropTypes.number.isRequired,
  numChurned: PropTypes.number.isRequired,
  churnRate: PropTypes.string.isRequired,
  arpa: PropTypes.number.isRequired,
  churnImprovement: PropTypes.number.isRequired,
  month1: PropTypes.number.isRequired,
  yearlyCumulative: PropTypes.number.isRequired,
  placement: PropTypes.string.isRequired,
};

export default CtaEmailForm;



// WEBPACK FOOTER //
// ./src/CtaEmailForm.js